import React from 'react'

import { Text } from '@wartek-id/text'
import { Button } from '@wartek-id/button-v1'
import { Sheet, SheetContent, SheetOverlay } from '@wartek-id/sheet-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'

import { useBCKSDesktopView } from 'app/BCKSPage/hooks/useBCKSDesktopView'

export interface BCKSProposalConfirmationProps {
  isOpen: boolean
  isLoading?: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  description: React.ReactNode
}

export const BCKSProposalConfirmation = ({
  isOpen,
  isLoading,
  onClose,
  onConfirm,
  title,
  description,
}: BCKSProposalConfirmationProps) => {
  const { isDesktop } = useBCKSDesktopView()

  const content = (
    <>
      <div className="flex flex-col ">
        <Text variant="heading-sm" as="h2" className=" mb-1">
          {title}
        </Text>
        <div className="my-2">
          {typeof description === 'string' ? (
            <Text variant="body-sm" color="subdued">
              {description}
            </Text>
          ) : (
            description
          )}
        </div>
      </div>
      <Button
        className="my-2"
        color="black"
        fullWidth
        isLoading={isLoading}
        onClick={onConfirm}
      >
        Saya setuju
      </Button>
      <Button
        color="white"
        className="mb-2"
        fullWidth
        disabled={isLoading}
        onClick={onClose}
      >
        Kembali
      </Button>
    </>
  )

  if (isDesktop) {
    return (
      <Dialog isOpen={isOpen} onClose={onClose}>
        <DialogOverlay />
        <DialogContent className="max-w-xl m-auto p-4">{content}</DialogContent>
      </Dialog>
    )
  }

  return (
    <Sheet isOpen={isOpen} onClose={onClose} type="alert">
      <SheetOverlay />
      <SheetContent className="max-w-xl m-auto p-4">{content}</SheetContent>
    </Sheet>
  )
}
